//import { StrictMode } from "react";
//import { createRoot } from "react-dom/client";
import "./styles.css";
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeflex/primeflex.css';

//import App from "./App";
//
//const root = createRoot(document.getElementById("root"));
//root.render(
//  <StrictMode>
//    <App />
//  </StrictMode>
//);




import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ onLoad: "login-required" }}   // auto login
  >
    <App />
  </ReactKeycloakProvider>
);


//root.render(
//  <ReactKeycloakProvider
//    authClient={keycloak}
//    initOptions={{
//      onLoad: "login-required",
//      pkceMethod: "S256",            // PKCE enabled, aligns with your client
//      checkLoginIframe: true,
//    }}
//  >
//    <App />
//  </ReactKeycloakProvider>
//);
